import dayjs from "dayjs";

export const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const ROW_HEIGHT = 42;
export const ROW_GAP = 6;
export const DATE_HEADER_HEIGHT = 28;

const CATEGORY_HIERARCHY = {
  fashion: 1,
  makeup: 2,
  "make up": 2,
  beauty: 2,
  pets: 3,
  pet: 3,
  food: 4,
  cooking: 4,
  baking: 4,
  fitness: 5,
  workout: 5,
  exercise: 5,
};

export const getCategoryPriority = (event) => {
  if (event.type === "contest") return 0;
  const categoryName = (event.category || "").toLowerCase();
  for (const [keyword, priority] of Object.entries(CATEGORY_HIERARCHY)) {
    if (categoryName.includes(keyword)) return priority + 10;
  }
  return 60;
};

export const getQuarterFromDate = (date) => {
  const month = date.month();
  return { year: date.year(), quarter: Math.floor(month / 3) + 1 };
};

export const getQuarterStart = (year, quarter) =>
  dayjs().year(year).month((quarter - 1) * 3).startOf("month");

export const getQuarterEnd = (year, quarter) =>
  dayjs().year(year).month(quarter * 3 - 1).endOf("month");

export const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getEventStatus = (event) => {
  const now = dayjs();
  const start = dayjs(event.startDate);
  const end = dayjs(event.endDate);
  if (event.type === "contest") {
    const isShowing = event.isCurrentlyShowing;
    if (now.isBefore(start)) return isShowing ? { color: "#dcfce7", borderColor: "#22c55e" } : { color: "#f3f4f6", borderColor: "#9ca3af" };
    if (now.isAfter(end)) return { color: "#fce7f3", borderColor: "#ec4899" };
    return isShowing ? { color: "#bbf7d0", borderColor: "#16a34a" } : { color: "#e5e7eb", borderColor: "#6b7280" };
  }
  if (event.type === "karaoke") {
    if (now.isBefore(start)) return { color: "#ede9fe", borderColor: "#8b5cf6" };
    if (now.isAfter(end)) return { color: "#fce7f3", borderColor: "#a855f7" };
    return { color: "#ddd6fe", borderColor: "#7c3aed" };
  }
  if (event.type === "dance") {
    if (now.isBefore(start)) return { color: "#ccfbf1", borderColor: "#14b8a6" };
    if (now.isAfter(end)) return { color: "#fce7f3", borderColor: "#0d9488" };
    return { color: "#99f6e4", borderColor: "#0f766e" };
  }
  if (now.isBefore(start)) return { color: "#fff3cd", borderColor: "#f59e0b" };
  if (now.isAfter(end)) return { color: "#fee2e2", borderColor: "#ef4444" };
  return { color: "#dbeafe", borderColor: "#3b82f6" };
};
